import { render, staticRenderFns } from "./assetDepreciationDetailDrawer.vue?vue&type=template&id=3b4502ec&scoped=true"
import script from "./assetDepreciationDetailDrawer.vue?vue&type=script&lang=js"
export * from "./assetDepreciationDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./assetDepreciationDetailDrawer.vue?vue&type=style&index=0&id=3b4502ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4502ec",
  null
  
)

export default component.exports